import { EventEmitter, Injectable, OnInit } from '@angular/core';

// interfaces 
import { IPedido } from '../interfaces/pedido';

// servicios 


// librerías y entronos
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IListaOpciones } from '../interfaces/lista-opciones';
import { UsuarioService } from './datos/usuario.service';
import { PedidosService } from './datos/pedidos.service';
import { NotificacionesService } from './notificaciones.service';
import { delay } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ModalPedidoOrigenService {
  apiURL: string = environment.apiURL;

  private _ocultarModal: boolean = true;
  private _pedido: IPedido = {};

  private opcionesList: IListaOpciones = {};
  loading: boolean = false;

  pedidoSubject: Subject<IPedido> = new Subject<IPedido>();
  modalClosed: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private usuarioSrv: UsuarioService,
    private pedidosSrv: PedidosService,
    private notificSrv: NotificacionesService,
  ) { }



  get pedido(): any {
    return this._pedido;
  }

  set pedido(value: any) {
    this._pedido = value;
    this.pedidoSubject.next(value);
  }

  get ocultarModal() {
    return this._ocultarModal;
  }


  cargarDatosPedido(id: number) {
    this.opcionesList = {};
    this.opcionesList.id = id;
    this.opcionesList.addPedidoExternoData = '1';

    this.loading = true;
    this.pedidosSrv.getLista(this.opcionesList)
      .pipe(delay(100))
      .subscribe((resp) => {
        this.loading = false;

        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje || 'Error desconocido');
          return;
        }

        this.pedido = resp.data[0];
        console.log('__cargarDatosPedido()  resp.data[0]=', resp.data[0]);
        console.log('__cargarDatosPedido() pedido=', this.pedido);

        this._ocultarModal = false;
      });
  }


  abrirModal() {
    if (this.pedido?.id) {
      this.cargarDatosPedido(this.pedido.id);
    }
    console.log('__abrirModal() (ModalPedidoOrigenService)', this.pedido)
  }

  cerrarModal() {
    // cerrar modal y emitir 'modalClosed' para que el subscriptor se entere
    this._ocultarModal = true;
    console.log('__cerrarModal() (ModalPedidoOrigenService)', this.pedido)
    this.modalClosed.emit();
  }

  ///// AUX ////

  errorAuth() {
    this.usuarioSrv.logOut();
    console.log('error', environment.apiErrorAuth);
    // this.notificacionesSrv.aviso('error', environment.apiErrorAuth);
  }

}
